<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa360-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
          :useBtnList="['btnRetrieve', 'btnExcel']"
          @btnRetrieve="btnRetrieve()"
          @btnExcel="onExporting()"
        >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top class="d-md-flex" outlined>
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Ship No :</span>
                        <v-col cols="1">
                          <v-autocomplete
                            v-model="shipNo"
                            :items="shipNoList"
                            outlined
                            dense
                            height="32"
                            clearable
                            @change="changeShipNo"
                          />
                        </v-col>

                        <i-label :label="'Lot No :'" class="pl-2" />
                        <v-col cols="1">
                          <v-autocomplete
                            v-model="lotNo"
                            :items="lotNoList"
                            outlined
                            dense
                            height="32"
                            clearable
                          />
                        </v-col>

                        <i-label :label="'Division :'" class="pl-2" />
                        <v-col cols="2">
                          <v-select
                            v-model="division"
                            :items="divisionList"
                            item-text="name"
                            item-value="value"
                            outlined
                            dense
                            height="32"
                            @change="changeCondition"
                          />
                        </v-col>

                        <v-checkbox
                          v-model="useClosingTime"
                          class="closing-time-check ma-0 ml-2"
                          hide-details
                          label="Closing Time"
                          @change="changeCondition"
                        />

                        <span class="pa-1 subTitle">Year :</span>
                        <v-col cols="1">
                          <v-select
                            v-model="closeYear"
                            :items="yearList"
                            outlined
                            dense
                            height="32"
                            :disabled="!useClosingTime"
                          />
                        </v-col>

                        <span class="pa-1 subTitle">Month :</span>
                        <v-col cols="1">
                          <v-select
                            v-model="closeMonth"
                            :items="monthList"
                            outlined
                            dense
                            height="32"
                            :disabled="!useClosingTime"
                          />
                        </v-col>

                        <span class="pa-1 subTitle">Times :</span>
                        <v-col cols="1">
                          <v-select
                            v-model="closeTimes"
                            :items="timesList"
                            outlined
                            dense
                            height="32"
                            :disabled="!useClosingTime"
                          />
                        </v-col>

                      </v-row>
                      <v-row dense class="ma-0">
                        <i-label :label="'Supplier :'" class="pl-2" />
                        <v-col cols="1">
                          <v-select
                            v-model="supplier"
                            :items="supplierList"
                            item-text="name"
                            item-value="value"
                            outlined
                            dense
                            height="32"
                          />
                        </v-col>

                        <v-checkbox
                          v-model="isDetail"
                          class="detail-check ma-0 ml-2"
                          hide-details
                          label="Detail"
                          @change="changeCondition"
                        />
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid
                    id="epmsa360"
                    :key="isDetail ? 'epmsa360-detail' : 'epmsa360-summary'"
                    :ref="epmsa360Ref"
                    class="listBox"
                    :data-source="gridMainList"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    key-expr="id"
                    :column-hiding-enabled="false"
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                    @optionChanged="optionChanged"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxScrolling mode="standard" show-scrollbar="always" />
                    <DxGrouping v-if="isDetail" :auto-expand-all="true" />
                    <DxColumn v-if="isDetail" :group-index="0" data-field="groupNm" caption="Sub" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="rnum" caption="No" width="50" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="80" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="lotNo" caption="Lot No" width="70" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="cutNo" caption="Cut No" width="125" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="divNm" caption="Type" width="120" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="cutGrp" caption="Cut Group" width="75" alignment="center" :allow-editing="false" header-cell-template="cutGrp"/>
                    <template #cutGrp>
                          <div>Cut<br/>Group</div>
                    </template>                    

                    <template v-if="isDetail">                      
                      <DxColumn caption="Cutting Order" alignment="center">
                        <DxColumn data-field="cutLotNo" caption="Cutting Lot No" width="95" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="dwgNo" caption="Drawing Page" width="110" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="machNm" caption="Machine" width="95" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="orderQty" caption="Qty" width="85" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                        <DxColumn data-field="orderWgt" caption="Wgt" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      </DxColumn>
                    </template>
                    <template v-else>
                      <DxColumn caption="Cutting Order" alignment="center">                        
                        <DxColumn data-field="orderQty" caption="Qty" width="85" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                        <DxColumn data-field="orderWgt" caption="Wgt" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      </DxColumn>
                    </template>

                     <template #notCfmQty>
                          <div>Not Conf.<br/>Qty</div>
                      </template>     
                     <template #notCfmWgt>
                          <div>Not Conf.<br/>Wgt</div>
                      </template>  
                    <DxColumn caption="Cutting Result" alignment="center">
                      <DxColumn data-field="nyCnfQty" caption="Not Conf. Qty" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" header-cell-template="notCfmQty"/>                     
                      <DxColumn data-field="nyCnfWgt" caption="Not Conf. Wgt" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" header-cell-template="notCfmWgt"/>                         
                      <DxColumn data-field="cnfQty" caption="Conf. Qty" width="85" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="cnfWgt" caption="Conf. Wgt" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="ctrUprice" caption="Contract Unit Price (WON)" width="115" data-type="number" format="#,###" alignment="right" :allow-editing="false" header-cell-template="contrUnitPrc"/>
                    <template #contrUnitPrc>
                          <div>Contract<br/>Unit Price<br/>(WON)</div>
                      </template>    
                    <DxColumn data-field="cutCnfDte" caption="Confirm Result Date" width="115" data-type="date" format="yyyy-mm-dd" alignment="center" :allow-editing="false" header-cell-template="cfmResDte"/>
                    <template #cfmResDte>
                          <div>Confirm<br/>Result Date</div>
                      </template> 
                      
                     <template #exchRateWon>
                          <div>Exch. Rate<br/>(WON/USD)</div>
                      </template>   
                      <template #exchRateUsd>
                          <div>Exch. Rate<br/>(VND/USD)</div>
                      </template> 
                    <DxColumn caption="Payment" alignment="center">
                      <DxColumn data-field="paidUprice" caption="U.Price (WON)" width="105" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="paidWgt" caption="WGT" width="95" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="paidAmt" caption="Amount (WON)" width="115" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="exchRateFor" caption="Exch. Rate (WON/USD)" width="120" data-type="number" format="#,##0.##" alignment="right" :allow-editing="false" header-cell-template="exchRateWon"/>                      
                      <DxColumn data-field="exchRate" caption="Exch. Rate (VND/USD)" width="120" data-type="number" format="#,###" alignment="right" :allow-editing="false" header-cell-template="exchRateUsd"/>                     
                      <DxColumn data-field="usd" caption="Amount (USD)" width="110" data-type="number" format="#,##0.##" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="vnd" caption="Amount (VND)" width="110" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="cls" caption="Closing Time" width="100" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="invoiceNo" caption="Invoice No" width="75" alignment="center" :allow-editing="false" header-cell-template="invNo"/>
                     <template #invNo>
                          <div>Invoice<br/>No</div>
                      </template> 
                    <DxSummary>
                      <DxTotalItem column="shipNo" summary-type="count" display-format="Total: {0}" />
                      <DxGroupItem
                        v-if="isDetail"
                        :show-in-group-footer="false"
                        :align-by-column="true"
                        column="orderQty"
                        summary-type="sum"
                        value-format="#,###"
                        display-format="{0}"
                      />
                      <DxGroupItem
                        v-if="isDetail"
                        :show-in-group-footer="false"
                        :align-by-column="true"
                        column="orderWgt"
                        summary-type="sum"
                        value-format="#,###"
                        display-format="{0}"
                      />
                      <DxTotalItem v-for="field in totalFields" :key="field" :column="field" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>
                    <DxPaging :enabled="true" :page-size="20" />
                    <DxPager :allowed-page-sizes="[20, 'all']" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn, DxEditing, DxGrouping, DxGroupItem, DxPager, DxPaging, DxScrolling, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { epmsa350LotNo } from '@/api/view/hip/A/epmsa350'
import { epmsa360Detail, epmsa360Summary } from '@/api/view/hip/A/epmsa360'

export default {
  name: 'epmsa360',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxGrouping,
    DxGroupItem,
    DxPager,
    DxPaging,
    DxScrolling,
    DxSummary,
    DxTotalItem
  },
  data() {
    const today = new Date()
    return {
      menuTitle: this.$route.meta.title,
      epmsa360Ref: 'epmsa360Ref',
      userMakerCd: this.$store.state.user.makerCd,
      shipNo: '',
      shipNoList: [],
      lotNo: '',
      lotNoList: [],
      division: '1',
      divisionList: [
        { name: '1. All', value: '1' },
        { name: '2. FPC', value: '2' },
        { name: '3. Not FPC', value: '3' },
        { name: '4. Steel Section', value: '4' },
        { name: '5. Desk House S.Section', value: '5' },
        { name: '6. Desk House S.Plate', value: '6' },
        { name: '7. T-Bar', value: '7' },
        { name: '8. T-Bar Cutting', value: '8' }
      ],
      useClosingTime: false,
      closeYear: String(today.getFullYear()),
      closeMonth: String(today.getMonth() + 1).padStart(2, '0'),
      closeTimes: '0',
      yearList: Array.from({ length: 11 }, (_, index) => String(today.getFullYear() - 5 + index)),
      monthList: Array.from({ length: 12 }, (_, index) => String(index + 1).padStart(2, '0')),
      timesList: Array.from({ length: 4 }, (_, index) => String(index)),
      supplier: '1',
      supplierList: [
        { name: 'All', value: '0' },
        { name: 'Jeil-Vina', value: '1' },
        { name: 'Deahyup', value: '2' }
      ],
      isDetail: false,
      gridMainList: [],
      mergeFields: ['shipNo', 'lotNo', 'cutNo', 'divNm', 'cutGrp', 'cutLotNo'],
      mergedCells: {},
      totalFields: ['orderQty', 'orderWgt', 'nyCnfQty', 'nyCnfWgt', 'cnfQty', 'cnfWgt', 'paidWgt', 'paidAmt', 'usd', 'vnd']
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epmsa360Ref)
    },
    isDivisionEight() {
      return this.division === '8'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      try {
        this.openLoading('searching')
        await this.getShipNoList()
      } finally {
        this.endLoading()
      }
    },
    async getShipNoList() {
      const res = await getShipNoList({ makerCd: this.userMakerCd })
      this.shipNoList = ['']
      res.list.forEach(item => {
        this.shipNoList.push(item.shipNo)
      })
    },
    async changeShipNo() {
      this.lotNo = ''
      this.lotNoList = ['']

      if (!this.shipNo) {
        return
      }

      const res = await epmsa350LotNo({ shipNo: this.shipNo })
      res.list.forEach(item => {
        this.lotNoList.push(item.lotNo)
      })
    },
    changeCondition() {
      this.resetMergedCells()
      this.gridMainList = []
    },
    resetMergedCells() {
      this.mergedCells = {}
    },
    cellPrepared(e) {
      if (!this.isDetail || e.rowType !== 'data' || !this.mergeFields.includes(e.column.dataField)) {
        return
      }

      const field = e.column.dataField
      const previousCell = this.mergedCells[field]

      if (previousCell && previousCell.groupNm === e.data.groupNm) {
        e.cellElement.style.display = 'none'
        previousCell.cellElement.rowSpan = Number(previousCell.cellElement.rowSpan || 1) + 1
        return
      }

      e.cellElement.style.verticalAlign = 'middle'
      this.mergedCells[field] = { groupNm: e.data.groupNm, cellElement: e.cellElement }
    },
    optionChanged(e) {
      if (e.fullName === 'paging.pageIndex') {
        this.resetMergedCells()
      }
    },
    getParams() {
      return {
        shipNo: this.shipNo || '',
        lotNo: this.lotNo || '',
        clsTime: this.useClosingTime ? `${this.closeYear}${this.closeMonth}${this.closeTimes}` : '',
        div: this.division,
        makerCd: this.supplier
      }
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') {
        return 0
      }

      const numberValue = Number(String(value).replace(/,/g, ''))
      return Number.isFinite(numberValue) ? numberValue : 0
    },
    mapGridData(list) {
      const numberFields = [...this.totalFields, 'paidUprice', 'ctrUprice', 'exchRate', 'exchRateFor']
      return list.map((item, index) => {
        const row = { ...item, id: index + 1, rnum: index + 1 }
        numberFields.forEach(field => {
          row[field] = this.toNumber(row[field])
        })
        return row
      })
    },
    async btnRetrieve() {
      if (!this.shipNo) {
        this.vToastify('Please select Ship No.', 'warn')
        return
      }

      this.resetMergedCells()
      this.gridMainList = []
      try {
        this.openLoading('searching')
        console.log('param ', this.getParams())
        const res = this.isDetail ? await epmsa360Detail(this.getParams()) : await epmsa360Summary(this.getParams())
        this.resetMergedCells()
        this.gridMainList = this.mapGridData(res.list || [])
      } finally {
        this.endLoading()
      }
    },
    totalFormat(e) {
      return Number(e.value || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })
    },
    onExporting(e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.isDetail ? 'Detail' : 'Summary')

      exportDataGrid({
        component: this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 3, column: 1 }
      }).then(() => {
        const headerRow = worksheet.getRow(3)
        const lastColumn = Math.max(headerRow.cellCount, 1)
        const titleRow = worksheet.getRow(1)
        const conditionRow = worksheet.getRow(2)

        worksheet.mergeCells(1, 1, 1, lastColumn)
        worksheet.mergeCells(2, 1, 2, lastColumn)
        titleRow.getCell(1).value = 'Cutting Result and Payment Status'
        titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 18, bold: true }
        titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' }
        conditionRow.getCell(1).value = `Ship No: ${this.shipNo || 'All'} / Lot No: ${this.lotNo || 'All'} / Division: ${this.division} / Closing Time: ${this.useClosingTime ? this.getParams().clsTime : 'All'} / Supplier: ${this.supplierList.find(item => item.value === this.supplier).name} / ${this.isDetail ? 'Detail' : 'Summary'}`
        conditionRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' }
      }).then(() => workbook.xlsx.writeBuffer()).then(buffer => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `CuttingResultPayment_${this.isDetail ? 'Detail' : 'Summary'}.xlsx`)
      })

      if (e) {
        e.cancel = true
      }
    }
  }
}
</script>

<style scoped>
.subTitle {
  font-weight: bold;
  color: black;
}

.closing-time-check,
.detail-check {
  flex: 0 0 auto;
}
</style>